import { apiRequest } from ".";

export const getClientActionsRequest = (filters) => {
  const {
    page='',
    limit='',
    status='',
    client=''
  } = filters;

  return apiRequest(
    `/admin/client-actions?page=${page}&limit=${limit}&status=${status}&client=${client}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getClientActionRequest = (id) => {
  return apiRequest(
    `/admin/client-actions/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const createClientActionRequest = (clientAction) => {
  return apiRequest(
    `/admin/client-actions`,
    {
      method: 'POST',
      body: JSON.stringify(clientAction)
    },
    true
  )
}

export const updateClientActionRequest = (clientAction) => {
  return apiRequest(
    `/admin/client-actions/${clientAction._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(clientAction)
    },
    true
  )
}

export const deleteClientActionRequest = (id) => {
  return apiRequest(
    `/admin/client-actions/${id}`,
    {
			method: 'DELETE'
    },
    true
  )
}